module.exports = __webpack_public_path__ + "static/media/spinal.683e29de.ogg";